import type { PropsWithChildren } from 'react';
import { Box } from '@mui/joy';

/** Signing documents stays readable without changing the user's app preference. */
export function LightSigningSurface({ children }: PropsWithChildren) {
  return <Box data-joy-color-scheme="light" sx={{ colorScheme: 'light', bgcolor: 'background.body', color: 'text.primary', minHeight: '100dvh' }}>{children}</Box>;
}
